import React, { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { GlobalStateContext } from './GlobalState';
import { Link, useNavigate } from 'react-router-dom';

const PlaylistSave = () => {
  const navigate = useNavigate();
  const { globalList, isLoggedInSpotify } = useContext(GlobalStateContext);
  const [playlistName, setPlaylistName] = React.useState('');
  const [isPublic, setIsPublic] = React.useState(true);
  const [message, setMessage] = React.useState('');

  const [saveSuccess, setSaveSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (globalList.length === 0) {
      setMessage('Please add songs to your playlist first');
      return;
    }

    try {
      const response = await fetch('/saveplaylistx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          playlistName: playlistName,
          list: globalList.map(song => song.id)
        }),
      });

      if (response.ok) {
        setSaveSuccess(true);
      } else {
        setMessage('Failed to save playlist');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('Error saving playlist');
    }
  };

  return (
    <div className="container">
      {!isLoggedInSpotify ? (
        <div className="text-center">
          <h1 className="cover-heading">Save Playlist</h1>
          <div className="alert alert-info" role="alert">
            <p>Login to Spotify to save your playlist</p>
            <a
              href="/login-home"

              style={{
                backgroundColor: '#007bff', // Example button styling
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                textDecoration: 'none', // Remove underline from link
                cursor: 'pointer',
              }}
            >
              Login with Spotify
            </a>
          </div>
        </div>
      ) : saveSuccess ? (
        <div className="text-center text-white">
          <h1 className="display-4">Playlist successfully saved!</h1>
          <p className="lead">You can run now! 🏃‍♂️</p>
          <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '5em' }}></i>
          <br /> <br />
          When you open the Spotify app, you will see your new playlist in the "Playlists" section.
        </div>
      ) : (
        <>
          <h1 className="cover-heading"><strong className="step-number">3</strong>Save Playlist</h1>
          {globalList.length === 0 ? (
            <div className="text-white">Please load songs first</div>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3 mx-auto text-center" style={{ maxWidth: '300px' }}>
                <Form.Label>Playlist Name</Form.Label>
                <Form.Control
                  type="text"
                  value={playlistName}
                  onChange={(e) => setPlaylistName(e.target.value)}
                  placeholder="Enter playlist name"
                  required
                  className="mb-2"
                />
                <Form.Check
                  type="checkbox"
                  label="Make playlist public"
                  checked={isPublic}
                  onChange={(e) => setIsPublic(e.target.checked)}
                  inline
                />
              </Form.Group>

              <div className="text-center d-flex justify-content-center gap-2">
                <Button variant="primary" type="submit">
                  Save Playlist
                </Button>
                <Button variant="info" onClick={() => navigate('/chat', { state: { systemContext: globalList } })}>
                  <i className="bi bi-chat-dots"></i> Open in Chat
                </Button>
              </div>

              {message && (
                <div className="mt-3 text-white">
                  {message}
                </div>
              )}
            </Form>
          )}

          {globalList.length > 0 && (
            <div className="mt-4">
              <h3>Playlist Contents:</h3>
              <div className="list-group">
                {globalList.map((song, index) => (
                  <div key={index} className="list-group-item bg-dark text-white border-secondary">
                    {song.artist} - {song.name}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PlaylistSave;
